let isAuthenticated = false;

export const getIsAuthenticated = (): boolean => isAuthenticated;

export const setIsAuthenticated = (authenticated: boolean): void => {
  isAuthenticated = authenticated;
};
